
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-gs-scroll-product]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const target = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-form');
      if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    });
  });

  const navLinks = Array.from(document.querySelectorAll('.gs-mini-nav a'));
  if (navLinks.length) {
    const getOffset = () => {
      const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '72', 10);
      const navH = document.querySelector('.gs-mini-nav')?.offsetHeight || 48;
      return headerH + navH + 18;
    };

    navLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || selector.charAt(0) !== '#') return;
        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.pageYOffset - getOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: reduced ? 'auto' : 'smooth' });
        navLinks.forEach((item) => item.classList.toggle('active', item === link));
      });
    });

    const targets = navLinks.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);
    const update = () => {
      let current = navLinks[0];
      targets.forEach((section) => {
        if (section.getBoundingClientRect().top <= getOffset()) {
          const selector = '#' + section.id;
          current = navLinks.find((link) => link.getAttribute('href') === selector) || current;
        }
      });
      navLinks.forEach((link) => link.classList.toggle('active', link === current));
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  document.querySelectorAll('.gs-video-card').forEach((card, index) => {
    card.addEventListener('click', () => {
      const rail = card.closest('.gs-pdp-body');
      if (!rail) return;
      rail.querySelectorAll('.gs-video-card').forEach((item) => item.classList.remove('active'));
      rail.querySelectorAll('.gs-video-dots button').forEach((dot) => dot.classList.remove('active'));
      card.classList.add('active');
      const dot = rail.querySelectorAll('.gs-video-dots button')[index];
      if (dot) dot.classList.add('active');
    });
  });
})();
